import React from 'react';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import PeriodSelector, { IDatePeriod } from 'src/components/period-selector';
import PeriodDisplay from 'src/components/period-display';
import ReportExporter from 'src/components/report-exporter';
import { OrderStatsSortOption, SortOrder } from 'src/graphql/report-service/generated/operations';
import StatsPagination from './pagination';

interface OrderStatsControlsProps {
  period: IDatePeriod | undefined;
  changePeriod: (period: IDatePeriod) => void;
  page: number;
  total: number;
  setPage: (page: number) => void;
  rowsPerPage: number;
  setRowsPerPage: (rows: number) => void;
  sortBy: OrderStatsSortOption;
  sortDirection: SortOrder;
}

const OrderStatsControls = function ({
  period,
  changePeriod,
  page,
  total,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  sortBy,
  sortDirection,
}: OrderStatsControlsProps) {
  return (
    <Card sx={{ p: 1.5 }}>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={2}>
          <PeriodSelector selectedPeriod={period} changePeriod={changePeriod} />
          <PeriodDisplay period={period} />
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <StatsPagination
            total={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
          <ReportExporter
            period={period}
            mode="orders"
            sortBy={sortBy}
            sortDirection={sortDirection}
          />
        </Stack>
      </Stack>
    </Card>
  );
};

export default OrderStatsControls;
